import { Container } from '../../../odie';

import { HalfIceBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const manifest = {
  image: 'ice/block.ice.half.png',
};

/*
    half full ice block view
*/
export class HalfIceBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: HalfIceBlockProps) {
    // create base view
    super();

    const ice = new FitWidthBlockSprite(manifest.image, props);

    this.addChild(ice);

    // position
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return [manifest.image];
  }
}
